module.exports = __webpack_public_path__ + "static/img/result_ls_lens_down.8670a56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/result_ls_lens_down.jpg
// module id = KsmG
// module chunks = 3